import react, { useEffect } from 'react';
import CartImage from "./Image";

import { useNavigate } from 'react-router-dom';


const OrderDetails = ({cartItems, dealsItem, halfAndHalfItems = [], handleUpdateQty, handleRemoveItem, removeID, orderType, selectedTables,   onEditCartItem,  existingOrderId }) => {
    const navigate = useNavigate();

    const handleAddMoreItems = (e) => {
      e.preventDefault();

      navigate('/takeaway', {
        state: {
          orderType: orderType,
          selectedTables:selectedTables,
          // existing_order_id only - NOT edit_order_id. edit_order_id would make the next
          // add-to-cart call attach the new item straight to this order (see
          // CartService::addSelectedDishesToCart), and Send to Kitchen would then attach it again
          // to the child order it creates via existing_order_id - the same item on both. Only
          // Send to Kitchen should attach anything; existing_order_id alone still gets Takeaway.js
          // to display this order's cart (see displayOrderId there).
          existing_order_id: existingOrderId
          // later you can add more state here
        }
      });
    };
    return (
        <div className="col-lg-8">
            <div className="cardStyle">
                <div className="table-responsive">
                    <table className="table tableStyle align-middle">
                        <thead>
                            <tr>
                                <th colSpan="2">Product</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th width="80">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <>
                            {dealsItem.map((deal_record, idx) => (
                                <>
                                    <tr key={idx}>  
                                        <td className="tableProImgCol">
                                            <CartImage
                                                            src={deal_record.product_thumbnail}
                                                            alt={deal_record.item_name}
                                                            imgClass="tableProImg"
                                                        />
                                        </td>
                                        <td colSpan={2}>
                                            <span className="proName d-block">{deal_record.item_name}</span>
                                            <span className="proDetail">{deal_record.selected_size}</span>
                                        </td>
                                        <td>${(deal_record.total_price).toFixed(2)}</td>
                                        <td>
                                            <div className="actionIcons">
                                                <button className="actionIcon"   onClick={() => handleRemoveItem(deal_record.cart_id)}  disabled={removeID === deal_record.cart_id}>
                                                    <svg width="20" height="20" className="cartRightIcon cursorPointer">
                                                        <use xlinkHref="./images/sprite.svg#iconTrash"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={5}>
                                            {deal_record[deal_record.cid] && Array.isArray(deal_record[deal_record.cid]) && 
                                                deal_record[deal_record.cid].length > 0 && (deal_record[deal_record.cid].map((nestedDeal) => (
                                                <tr key={nestedDeal.id}>
                                                    <td className="tableProImgCol">
                                                        <CartImage
                                                            src={nestedDeal.product_thumbnail}
                                                            alt={nestedDeal.item_name}
                                                            imgClass="tableProImg"
                                                        />
                                                    </td>
                                                    <td>
                                                        <span className="proName d-block">{nestedDeal.item_name}</span>
                                                        <span className="proDetail">{nestedDeal.selected_size}</span>
                                                        {nestedDeal.dealIngrade && (
                                                            <span className="proDetail d-block" dangerouslySetInnerHTML={{ __html: nestedDeal.dealIngrade }} />
                                                        )}
                                                        {nestedDeal.dealUpgrade && (
                                                            <span className="proDetail d-block" dangerouslySetInnerHTML={{ __html: nestedDeal.dealUpgrade }} />
                                                        )}
                                                        {nestedDeal.comments && (
                                                            <span className="proDetail d-block fst-italic">Comment: {nestedDeal.comments}</span>
                                                        )}
                                                    </td>
                                                    <td></td>
                                                    <td>${(nestedDeal.total_price).toFixed(2)}</td>
                                                    <td>
                                                        <div className="actionIcons">
                                                            <a href="order-review-edit.html" className="actionIcon">
                                                                <svg width="20" height="20" className="editIcon">
                                                                    <use xlinkHref="./images/sprite.svg#iconEdit"></use>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )))}
                                        </td>
                                    </tr>
                                </>
                            ))}

                            {halfAndHalfItems.map((hnh_record, idx) => (
                                <>
                                    <tr key={`hnh-${idx}`}>
                                        <td className="tableProImgCol">
                                            <CartImage
                                                            src={hnh_record.product_thumbnail}
                                                            alt={hnh_record.item_name}
                                                            imgClass="tableProImg"
                                                        />
                                        </td>
                                        <td colSpan={2}>
                                            <span className="proName d-block">{hnh_record.item_name}</span>
                                            {hnh_record.crust_label && (
                                                <span className="proDetail d-block">Crust: {hnh_record.crust_label}(${hnh_record.crust_price})</span>
                                            )}
                                        </td>
                                        <td>${(hnh_record.total_price).toFixed(2)}</td>
                                        <td>
                                            <div className="actionIcons">
                                                <button className="actionIcon"   onClick={() => handleRemoveItem(hnh_record.cart_id)}  disabled={removeID === hnh_record.cart_id}>
                                                    <svg width="20" height="20" className="cartRightIcon cursorPointer">
                                                        <use xlinkHref="./images/sprite.svg#iconTrash"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={5}>
                                            {hnh_record[hnh_record.cid] && Array.isArray(hnh_record[hnh_record.cid]) &&
                                                hnh_record[hnh_record.cid].length > 0 && (hnh_record[hnh_record.cid].map((half) => (
                                                <tr key={half.cart_id}>
                                                    <td className="tableProImgCol">
                                                        <CartImage
                                                            src={half.product_thumbnail}
                                                            alt={half.item_name}
                                                            imgClass="tableProImg"
                                                        />
                                                    </td>
                                                    <td>
                                                        <span className="proName d-block">{half.item_name}</span>
                                                        <span className="proDetail">{half.selected_size}</span>
                                                        {half.product_detail_text && (
                                                            <span className="proDetail d-block" dangerouslySetInnerHTML={{ __html: half.product_detail_text }} />
                                                        )}
                                                        {half.toppings && half.toppings.map((topping) => (
                                                            <span key={topping.group} className="proDetail d-block">
                                                                {topping.group}: {topping.label}(${topping.price})
                                                            </span>
                                                        ))}
                                                        {half.comments && (
                                                            <span className="proDetail d-block fst-italic">Comment: {half.comments}</span>
                                                        )}
                                                    </td>
                                                    <td></td>
                                                    <td>${(half.total_price).toFixed(2)}</td>
                                                    <td></td>
                                                </tr>
                                            )))}
                                        </td>
                                    </tr>
                                </>
                            ))}

                            {cartItems.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="tableProImgCol">
                                        <CartImage
                                                            src={row.first_image_url}
                                                            alt={row.item_name}
                                                            imgClass="tableProImg"
                                                        />
                                        {/* <img src="./images/product-img-1.webp" alt="..." className="tableProImg" /> */}
                                    </td>
                                    <td>
                                        <span className="proName d-block">{row.item_name}</span>
                                        <span className="proDetail">{row.selected_size}</span>
                                        <p>
                                        {row.product_detail_text ? (
                                            <span dangerouslySetInnerHTML={{ __html: row.product_detail_text }} />
                                        ) : (
                                            <span></span>
                                        )}
                                        </p>
                                        {row.comments && (
                                            <span className="proDetail d-block fst-italic">Comment: {row.comments}</span>
                                        )}
                                    </td>
                                    <td>
                                        <div className="quantitySelector">
                                            <span className="qtyBtn minus"  onClick={() =>
                                            handleUpdateQty(row.cart_id, row.item_quantity - 1)
                                            }>
                                                <svg width="8" height="8">
                                                    <use xlinkHref="./images/sprite.svg#iconMinus"></use>
                                                </svg>
                                            </span>
                                            <input type="number" className="form-control quantityInput" value={row.item_quantity} min="1" readOnly />
                                            <span className="qtyBtn plus"  onClick={() =>
                                            handleUpdateQty(row.cart_id, row.item_quantity + 1)
                                            }>
                                                <svg width="8" height="8" className="plus">
                                                    <use xlinkHref="./images/sprite.svg#iconPlus"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </td>
                                    <td>${(row.total_price).toFixed(2)}</td>
                                    <td>
                                        <div className="actionIcons">
                                        <button
                                            className="actionIcon"
                                            onClick={() => onEditCartItem(row)}
                                            >
                                            <svg width="20" height="20" className="editIcon">
                                                <use xlinkHref="./images/sprite.svg#iconEdit" />
                                            </svg>
                                        </button>
                                            <button className="actionIcon"   onClick={() => handleRemoveItem(row.cart_id)}  disabled={removeID === row.cart_id}>
                                                <svg width="20" height="20" className="cartRightIcon cursorPointer">
                                                    <use xlinkHref="./images/sprite.svg#iconTrash"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </>
                        </tbody>
                    </table>
                </div>
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <a href="#" className="btn iconBtn btnPrimary"  onClick={handleAddMoreItems}> 
                            <span>Add More Items</span>
                            <svg width="20" height="20" className="btnIcon">
                                <use xlinkHref="./images/sprite.svg#iconNextArrow"></use>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderDetails;